import { z } from 'zod';
const PREFIX = ['conversations', 'session'];
const STORAGE_KEY = '_varos_assistant_session';
// SessionDao schema for serialization/deserialization
const SessionDaoSchema = z.object({
    id: z.string(),
    token: z.string(),
    metadata: z.record(z.any()),
    createdAt: z.string().datetime(),
});
export function createSessionRepository(config) {
    const { repository, client } = config;
    // Helper function to generate consistent query keys
    const getQueryKey = (context) => [
        ...PREFIX,
        context.principal?.id,
    ];
    // Helper function to get cached session from localStorage
    const getCachedSession = () => {
        try {
            const stored = window.localStorage.getItem(STORAGE_KEY);
            if (!stored)
                return null;
            const parsed = JSON.parse(stored);
            const validated = SessionDaoSchema.safeParse(parsed);
            if (validated.success) {
                return validated.data;
            }
            // Clear invalid data
            window.localStorage.removeItem(STORAGE_KEY);
            return null;
        }
        catch {
            // Clear corrupted data
            try {
                window.localStorage.removeItem(STORAGE_KEY);
            }
            catch {
                // Ignore localStorage errors
            }
            return null;
        }
    };
    // Helper function to set session in localStorage
    const setCachedSession = (sessionDao) => {
        try {
            const serialized = JSON.stringify(sessionDao);
            window.localStorage.setItem(STORAGE_KEY, serialized);
        }
        catch {
            // Ignore localStorage errors
        }
    };
    return {
        useLookup(context, props, options) {
            const queryKey = getQueryKey(context);
            const query = repository.useQuery({
                ...options,
                queryKey: [...queryKey, props],
                async queryFn() {
                    // First, try to get existing session from localStorage
                    const cachedSession = getCachedSession();
                    if (cachedSession) {
                        // Return the cached session as SessionObject format
                        return {
                            id: cachedSession.id,
                            object: 'session',
                            token: cachedSession.token,
                            metadata: cachedSession.metadata,
                            created_at: new Date(cachedSession.createdAt),
                        };
                    }
                    // Create a new session if no valid cached session exists
                    const response = await client.sessionCreate({
                        sessionCreatePayload: props,
                    }, {
                        headers: {
                            // NOTE anonymous principles are supported for this endpoint
                            Authorization: undefined,
                        },
                    });
                    console.log('session response', response.data);
                    // Cache the new session as SessionDao
                    const sessionDao = {
                        id: response.data.id,
                        token: response.data.token,
                        metadata: response.data.metadata,
                        createdAt: response.data.created_at.toISOString(),
                    };
                    setCachedSession(sessionDao);
                    return response.data;
                },
            });
            return query;
        },
    };
}
//# sourceMappingURL=sessionRepository.js.map